import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './pet-rakunori.actions';
import { PetRakunoriState } from './pet-rakunori.state';

/**
 * petRakunori initial state
 */
export const petRakunoriInitialState: PetRakunoriState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for PetRakunori Store
 */
export const petRakunoriReducerFeatures: ReducerTypes<PetRakunoriState, ActionCreator[]>[] = [
  on(actions.setPetRakunori, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updatePetRakunori, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetPetRakunori, () => petRakunoriInitialState),

  on(actions.cancelPetRakunoriRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failPetRakunori, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setPetRakunoriFromApi, actions.updatePetRakunoriFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * PetRakunori Store reducer
 */
export const petRakunoriReducer = createReducer(petRakunoriInitialState, ...petRakunoriReducerFeatures);
